import React, { useState } from "react";
import { MainContainer, Wrapper, MenuWrapper } from "./Layout.styled";
import { Grid, useTheme } from "@mui/material";
import MenuItem from "../components/MenuItem";
import { StyledLink } from "../components";
import { MainPagesPath } from "../routing/Paths";
import Icon from "../components/Icon";
import { useSelector } from "react-redux";

const DrawerLayout = (props) => {
  const [navCollapsed, setNavCollapsed] = useState(false);
  const permissions = useSelector((state) => state.user.permissions);

  const isAdmin =
    permissions?.appIDs?.includes("3") && permissions?.moduleIDs?.includes("0");

  const TabLink = ({
    title,
    to,
    active,
    iconName = "",
    hideItemName,
    isVendor,
  }) => {
    const theme = useTheme();
    return (
      <StyledLink
        color={theme.primary}
        title={title}
        to={to}
        style={{ width: "100%" }}
      >
        <MenuItem
          isVendor={isVendor}
          hideItemName={hideItemName}
          active={active}
          iconName={iconName}
        >
          {title}
        </MenuItem>
      </StyledLink>
    );
  };

  return (
    <MainContainer>
      <MenuWrapper isCollapsed={navCollapsed}>
        {!navCollapsed && (
          <Grid container spacing={2} marginTop={1}>
            {isAdmin && (
              <Grid item xs={12}>
                <TabLink
                  title={"Document Management"}
                  to={MainPagesPath.schemes}
                  active={true}
                />
              </Grid>
            )}
            <Grid item xs={12}>
              <TabLink
                title={"Announcements/Notifications"}
                to={MainPagesPath.allPromotions}
                active={true}
              />
            </Grid>
            <Grid item xs={12}>
              <TabLink
                title={"Machine Models"}
                to={MainPagesPath.machineModels}
                active={true}
              />
            </Grid>
            {isAdmin && (
              <Grid item xs={12}>
                <TabLink
                  title={"Editors"}
                  to={MainPagesPath.allEditors}
                  active={true}
                />
              </Grid>
            )}
          </Grid>
        )}
      </MenuWrapper>
      <Wrapper>
        <div
          onClick={() => setNavCollapsed(!navCollapsed)}
          style={{
            width: "fit-content",
            position: "absolute",
            top: "50%",
            zIndex: 1,
            transform: `rotate(${navCollapsed ? "-90deg" : "90deg"})`,
            cursor: "pointer",
            background: "#003e85",
            padding: "0px 12px 5px 12px",
            marginLeft: -10,
            display: "flex",
          }}
        >
          <Icon
            width="15"
            icon="downIcon"
            color="white"
            height="15"
            style={{}}
            onClick={() => setNavCollapsed(!navCollapsed)}
          />
        </div>
        {props.children}
      </Wrapper>
    </MainContainer>
  );
};

export default DrawerLayout;
